export interface SampleDataSet {
  id: string;
  name: string;
  description: string;
  columns: string[];
  rows: Record<string, unknown>[];
}

export const sampleDataSets: SampleDataSet[] = [
  {
    id: 'sales',
    name: 'Sales Pipeline',
    description: 'Monthly revenue, orders, and conversion by product',
    columns: ['month', 'product', 'region', 'revenue', 'orders', 'conversion'],
    rows: [
      {
        month: 'Jan',
        product: 'Product A',
        region: 'North',
        revenue: 15200,
        orders: 85,
        conversion: 3.2,
      },
      {
        month: 'Jan',
        product: 'Product B',
        region: 'South',
        revenue: 9800,
        orders: 62,
        conversion: 2.8,
      },
      {
        month: 'Jan',
        product: 'Product C',
        region: 'East',
        revenue: 7200,
        orders: 48,
        conversion: 3.5,
      },
      {
        month: 'Feb',
        product: 'Product A',
        region: 'North',
        revenue: 16800,
        orders: 92,
        conversion: 3.4,
      },
      {
        month: 'Feb',
        product: 'Product B',
        region: 'South',
        revenue: 10200,
        orders: 68,
        conversion: 3.1,
      },
      {
        month: 'Feb',
        product: 'Product C',
        region: 'East',
        revenue: 7800,
        orders: 52,
        conversion: 3.8,
      },
      {
        month: 'Mar',
        product: 'Product A',
        region: 'North',
        revenue: 18100,
        orders: 98,
        conversion: 3.7,
      },
      {
        month: 'Mar',
        product: 'Product B',
        region: 'South',
        revenue: 11200,
        orders: 72,
        conversion: 3.3,
      },
      {
        month: 'Mar',
        product: 'Product C',
        region: 'East',
        revenue: 8500,
        orders: 56,
        conversion: 4.1,
      },
      {
        month: 'Apr',
        product: 'Product A',
        region: 'North',
        revenue: 17200,
        orders: 90,
        conversion: 3.5,
      },
      {
        month: 'Apr',
        product: 'Product B',
        region: 'South',
        revenue: 10500,
        orders: 65,
        conversion: 3.0,
      },
      {
        month: 'Apr',
        product: 'Product C',
        region: 'East',
        revenue: 8100,
        orders: 50,
        conversion: 3.6,
      },
      {
        month: 'May',
        product: 'Product A',
        region: 'North',
        revenue: 19500,
        orders: 105,
        conversion: 4.0,
      },
      {
        month: 'May',
        product: 'Product B',
        region: 'South',
        revenue: 11800,
        orders: 76,
        conversion: 3.5,
      },
      {
        month: 'May',
        product: 'Product C',
        region: 'East',
        revenue: 9200,
        orders: 60,
        conversion: 4.3,
      },
      {
        month: 'Jun',
        product: 'Product A',
        region: 'North',
        revenue: 21200,
        orders: 112,
        conversion: 4.2,
      },
      {
        month: 'Jun',
        product: 'Product B',
        region: 'South',
        revenue: 12800,
        orders: 82,
        conversion: 3.7,
      },
      {
        month: 'Jun',
        product: 'Product C',
        region: 'East',
        revenue: 10100,
        orders: 65,
        conversion: 4.5,
      },
    ],
  },
  {
    id: 'users',
    name: 'User Analytics',
    description: 'Monthly user metrics by tier and region',
    columns: ['month', 'tier', 'region', 'activeUsers', 'newSignups', 'churn', 'satisfaction'],
    rows: [
      {
        month: 'Jan',
        tier: 'Free',
        region: 'US',
        activeUsers: 4200,
        newSignups: 850,
        churn: 5.8,
        satisfaction: 3.2,
      },
      {
        month: 'Jan',
        tier: 'Pro',
        region: 'US',
        activeUsers: 2800,
        newSignups: 320,
        churn: 3.1,
        satisfaction: 4.1,
      },
      {
        month: 'Jan',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1200,
        newSignups: 45,
        churn: 1.2,
        satisfaction: 4.8,
      },
      {
        month: 'Feb',
        tier: 'Free',
        region: 'US',
        activeUsers: 4450,
        newSignups: 920,
        churn: 5.5,
        satisfaction: 3.3,
      },
      {
        month: 'Feb',
        tier: 'Pro',
        region: 'US',
        activeUsers: 2950,
        newSignups: 340,
        churn: 2.9,
        satisfaction: 4.2,
      },
      {
        month: 'Feb',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1250,
        newSignups: 48,
        churn: 1.0,
        satisfaction: 4.8,
      },
      {
        month: 'Mar',
        tier: 'Free',
        region: 'US',
        activeUsers: 4700,
        newSignups: 980,
        churn: 5.2,
        satisfaction: 3.4,
      },
      {
        month: 'Mar',
        tier: 'Pro',
        region: 'US',
        activeUsers: 3100,
        newSignups: 365,
        churn: 2.7,
        satisfaction: 4.3,
      },
      {
        month: 'Mar',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1300,
        newSignups: 52,
        churn: 0.9,
        satisfaction: 4.9,
      },
      {
        month: 'Apr',
        tier: 'Free',
        region: 'US',
        activeUsers: 4600,
        newSignups: 880,
        churn: 5.4,
        satisfaction: 3.3,
      },
      {
        month: 'Apr',
        tier: 'Pro',
        region: 'US',
        activeUsers: 3050,
        newSignups: 350,
        churn: 2.8,
        satisfaction: 4.2,
      },
      {
        month: 'Apr',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1280,
        newSignups: 50,
        churn: 1.1,
        satisfaction: 4.8,
      },
      {
        month: 'May',
        tier: 'Free',
        region: 'US',
        activeUsers: 5100,
        newSignups: 1050,
        churn: 4.8,
        satisfaction: 3.5,
      },
      {
        month: 'May',
        tier: 'Pro',
        region: 'US',
        activeUsers: 3350,
        newSignups: 390,
        churn: 2.5,
        satisfaction: 4.4,
      },
      {
        month: 'May',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1380,
        newSignups: 55,
        churn: 0.8,
        satisfaction: 4.9,
      },
      {
        month: 'Jun',
        tier: 'Free',
        region: 'US',
        activeUsers: 5600,
        newSignups: 1150,
        churn: 4.5,
        satisfaction: 3.6,
      },
      {
        month: 'Jun',
        tier: 'Pro',
        region: 'US',
        activeUsers: 3650,
        newSignups: 420,
        churn: 2.2,
        satisfaction: 4.5,
      },
      {
        month: 'Jun',
        tier: 'Enterprise',
        region: 'US',
        activeUsers: 1450,
        newSignups: 58,
        churn: 0.7,
        satisfaction: 4.9,
      },
    ],
  },
  {
    id: 'finance',
    name: 'Financial Summary',
    description: 'Quarterly revenue, expenses, and profit by department',
    columns: ['quarter', 'department', 'revenue', 'expenses', 'profit', 'headcount'],
    rows: [
      {
        quarter: 'Q1',
        department: 'Engineering',
        revenue: 120000,
        expenses: 95000,
        profit: 25000,
        headcount: 45,
      },
      {
        quarter: 'Q1',
        department: 'Marketing',
        revenue: 85000,
        expenses: 62000,
        profit: 23000,
        headcount: 18,
      },
      {
        quarter: 'Q1',
        department: 'Sales',
        revenue: 58000,
        expenses: 28000,
        profit: 30000,
        headcount: 22,
      },
      {
        quarter: 'Q1',
        department: 'Operations',
        revenue: 22000,
        expenses: 10000,
        profit: 12000,
        headcount: 12,
      },
      {
        quarter: 'Q2',
        department: 'Engineering',
        revenue: 132000,
        expenses: 101000,
        profit: 31000,
        headcount: 48,
      },
      {
        quarter: 'Q2',
        department: 'Marketing',
        revenue: 92000,
        expenses: 68000,
        profit: 24000,
        headcount: 20,
      },
      {
        quarter: 'Q2',
        department: 'Sales',
        revenue: 62000,
        expenses: 29500,
        profit: 32500,
        headcount: 24,
      },
      {
        quarter: 'Q2',
        department: 'Operations',
        revenue: 26000,
        expenses: 9500,
        profit: 16500,
        headcount: 14,
      },
      {
        quarter: 'Q3',
        department: 'Engineering',
        revenue: 128000,
        expenses: 106000,
        profit: 22000,
        headcount: 50,
      },
      {
        quarter: 'Q3',
        department: 'Marketing',
        revenue: 88000,
        expenses: 71000,
        profit: 17000,
        headcount: 22,
      },
      {
        quarter: 'Q3',
        department: 'Sales',
        revenue: 58000,
        expenses: 30500,
        profit: 27500,
        headcount: 26,
      },
      {
        quarter: 'Q3',
        department: 'Operations',
        revenue: 24000,
        expenses: 7500,
        profit: 16500,
        headcount: 15,
      },
      {
        quarter: 'Q4',
        department: 'Engineering',
        revenue: 148000,
        expenses: 112000,
        profit: 36000,
        headcount: 52,
      },
      {
        quarter: 'Q4',
        department: 'Marketing',
        revenue: 102000,
        expenses: 75000,
        profit: 27000,
        headcount: 24,
      },
      {
        quarter: 'Q4',
        department: 'Sales',
        revenue: 68000,
        expenses: 34500,
        profit: 33500,
        headcount: 28,
      },
      {
        quarter: 'Q4',
        department: 'Operations',
        revenue: 38000,
        expenses: 10500,
        profit: 27500,
        headcount: 16,
      },
    ],
  },
  {
    id: 'marketing',
    name: 'Marketing Campaigns',
    description: 'Weekly campaign performance by channel',
    columns: ['week', 'channel', 'impressions', 'clicks', 'conversions', 'spend', 'roas'],
    rows: [
      {
        week: 'Week 1',
        channel: 'Google Ads',
        impressions: 28500,
        clicks: 3200,
        conversions: 410,
        spend: 8500,
        roas: 3.8,
      },
      {
        week: 'Week 1',
        channel: 'Social Media',
        impressions: 19200,
        clicks: 2100,
        conversions: 280,
        spend: 6200,
        roas: 4.2,
      },
      {
        week: 'Week 1',
        channel: 'Email',
        impressions: 12400,
        clicks: 1800,
        conversions: 185,
        spend: 2400,
        roas: 12.5,
      },
      {
        week: 'Week 2',
        channel: 'Google Ads',
        impressions: 31200,
        clicks: 4100,
        conversions: 530,
        spend: 9200,
        roas: 4.1,
      },
      {
        week: 'Week 2',
        channel: 'Social Media',
        impressions: 22100,
        clicks: 2400,
        conversions: 310,
        spend: 6800,
        roas: 4.5,
      },
      {
        week: 'Week 2',
        channel: 'Email',
        impressions: 13500,
        clicks: 1950,
        conversions: 210,
        spend: 2400,
        roas: 13.2,
      },
      {
        week: 'Week 3',
        channel: 'Google Ads',
        impressions: 29800,
        clicks: 3800,
        conversions: 490,
        spend: 8800,
        roas: 3.9,
      },
      {
        week: 'Week 3',
        channel: 'Social Media',
        impressions: 20500,
        clicks: 2250,
        conversions: 290,
        spend: 6500,
        roas: 4.3,
      },
      {
        week: 'Week 3',
        channel: 'Email',
        impressions: 12800,
        clicks: 1850,
        conversions: 195,
        spend: 2400,
        roas: 12.8,
      },
      {
        week: 'Week 4',
        channel: 'Google Ads',
        impressions: 35200,
        clicks: 4900,
        conversions: 620,
        spend: 10500,
        roas: 4.4,
      },
      {
        week: 'Week 4',
        channel: 'Social Media',
        impressions: 24500,
        clicks: 2800,
        conversions: 350,
        spend: 7200,
        roas: 4.8,
      },
      {
        week: 'Week 4',
        channel: 'Email',
        impressions: 14200,
        clicks: 2100,
        conversions: 230,
        spend: 2400,
        roas: 14.1,
      },
    ],
  },
  {
    id: 'traffic',
    name: 'Traffic Sources',
    description: 'Daily website visitors by source and device',
    columns: ['day', 'source', 'device', 'visitors', 'bounceRate', 'avgDuration'],
    rows: [
      {
        day: 'Mon',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 3200,
        bounceRate: 35,
        avgDuration: 210,
      },
      {
        day: 'Mon',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 1800,
        bounceRate: 42,
        avgDuration: 150,
      },
      {
        day: 'Mon',
        source: 'Direct',
        device: 'Desktop',
        visitors: 2100,
        bounceRate: 38,
        avgDuration: 180,
      },
      {
        day: 'Mon',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1200,
        bounceRate: 48,
        avgDuration: 120,
      },
      {
        day: 'Mon',
        source: 'Social',
        device: 'Mobile',
        visitors: 1400,
        bounceRate: 52,
        avgDuration: 95,
      },
      {
        day: 'Tue',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 3500,
        bounceRate: 33,
        avgDuration: 220,
      },
      {
        day: 'Tue',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2000,
        bounceRate: 40,
        avgDuration: 160,
      },
      {
        day: 'Tue',
        source: 'Direct',
        device: 'Desktop',
        visitors: 2300,
        bounceRate: 36,
        avgDuration: 190,
      },
      {
        day: 'Tue',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1300,
        bounceRate: 45,
        avgDuration: 125,
      },
      {
        day: 'Tue',
        source: 'Social',
        device: 'Mobile',
        visitors: 1600,
        bounceRate: 50,
        avgDuration: 100,
      },
      {
        day: 'Wed',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 3800,
        bounceRate: 32,
        avgDuration: 230,
      },
      {
        day: 'Wed',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2200,
        bounceRate: 38,
        avgDuration: 170,
      },
      {
        day: 'Wed',
        source: 'Direct',
        device: 'Desktop',
        visitors: 2500,
        bounceRate: 35,
        avgDuration: 200,
      },
      {
        day: 'Wed',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1400,
        bounceRate: 42,
        avgDuration: 130,
      },
      {
        day: 'Wed',
        source: 'Social',
        device: 'Mobile',
        visitors: 1800,
        bounceRate: 48,
        avgDuration: 105,
      },
      {
        day: 'Thu',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 3600,
        bounceRate: 34,
        avgDuration: 215,
      },
      {
        day: 'Thu',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2000,
        bounceRate: 41,
        avgDuration: 155,
      },
      {
        day: 'Thu',
        source: 'Direct',
        device: 'Desktop',
        visitors: 2400,
        bounceRate: 37,
        avgDuration: 185,
      },
      {
        day: 'Thu',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1300,
        bounceRate: 46,
        avgDuration: 120,
      },
      {
        day: 'Thu',
        source: 'Social',
        device: 'Mobile',
        visitors: 1700,
        bounceRate: 51,
        avgDuration: 98,
      },
      {
        day: 'Fri',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 3900,
        bounceRate: 31,
        avgDuration: 240,
      },
      {
        day: 'Fri',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2400,
        bounceRate: 37,
        avgDuration: 175,
      },
      {
        day: 'Fri',
        source: 'Direct',
        device: 'Desktop',
        visitors: 2700,
        bounceRate: 34,
        avgDuration: 210,
      },
      {
        day: 'Fri',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1500,
        bounceRate: 40,
        avgDuration: 135,
      },
      {
        day: 'Fri',
        source: 'Social',
        device: 'Mobile',
        visitors: 2000,
        bounceRate: 45,
        avgDuration: 110,
      },
      {
        day: 'Sat',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 2100,
        bounceRate: 28,
        avgDuration: 190,
      },
      {
        day: 'Sat',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2800,
        bounceRate: 35,
        avgDuration: 180,
      },
      {
        day: 'Sat',
        source: 'Direct',
        device: 'Desktop',
        visitors: 1400,
        bounceRate: 32,
        avgDuration: 160,
      },
      {
        day: 'Sat',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1800,
        bounceRate: 38,
        avgDuration: 145,
      },
      {
        day: 'Sat',
        source: 'Social',
        device: 'Mobile',
        visitors: 2200,
        bounceRate: 42,
        avgDuration: 120,
      },
      {
        day: 'Sun',
        source: 'Organic Search',
        device: 'Desktop',
        visitors: 1500,
        bounceRate: 30,
        avgDuration: 185,
      },
      {
        day: 'Sun',
        source: 'Organic Search',
        device: 'Mobile',
        visitors: 2200,
        bounceRate: 36,
        avgDuration: 175,
      },
      {
        day: 'Sun',
        source: 'Direct',
        device: 'Desktop',
        visitors: 1000,
        bounceRate: 33,
        avgDuration: 155,
      },
      {
        day: 'Sun',
        source: 'Direct',
        device: 'Mobile',
        visitors: 1400,
        bounceRate: 40,
        avgDuration: 140,
      },
      {
        day: 'Sun',
        source: 'Social',
        device: 'Mobile',
        visitors: 1800,
        bounceRate: 44,
        avgDuration: 115,
      },
    ],
  },
  {
    id: 'support',
    name: 'Support Metrics',
    description: 'Monthly support tickets by category and priority',
    columns: ['month', 'category', 'priority', 'tickets', 'resolved', 'satisfaction', 'avgHours'],
    rows: [
      {
        month: 'Jan',
        category: 'Bug Report',
        priority: 'High',
        tickets: 120,
        resolved: 112,
        satisfaction: 3.5,
        avgHours: 8.2,
      },
      {
        month: 'Jan',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 85,
        resolved: 80,
        satisfaction: 4.0,
        avgHours: 18.5,
      },
      {
        month: 'Jan',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 95,
        resolved: 75,
        satisfaction: 3.8,
        avgHours: 24.0,
      },
      {
        month: 'Jan',
        category: 'Account Issue',
        priority: 'High',
        tickets: 65,
        resolved: 63,
        satisfaction: 4.2,
        avgHours: 2.5,
      },
      {
        month: 'Jan',
        category: 'Billing',
        priority: 'Medium',
        tickets: 55,
        resolved: 54,
        satisfaction: 4.5,
        avgHours: 1.8,
      },
      {
        month: 'Feb',
        category: 'Bug Report',
        priority: 'High',
        tickets: 105,
        resolved: 98,
        satisfaction: 3.6,
        avgHours: 7.5,
      },
      {
        month: 'Feb',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 72,
        resolved: 68,
        satisfaction: 4.1,
        avgHours: 16.2,
      },
      {
        month: 'Feb',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 88,
        resolved: 72,
        satisfaction: 3.9,
        avgHours: 22.5,
      },
      {
        month: 'Feb',
        category: 'Account Issue',
        priority: 'High',
        tickets: 58,
        resolved: 57,
        satisfaction: 4.3,
        avgHours: 2.2,
      },
      {
        month: 'Feb',
        category: 'Billing',
        priority: 'Medium',
        tickets: 50,
        resolved: 49,
        satisfaction: 4.6,
        avgHours: 1.5,
      },
      {
        month: 'Mar',
        category: 'Bug Report',
        priority: 'High',
        tickets: 140,
        resolved: 130,
        satisfaction: 3.4,
        avgHours: 8.8,
      },
      {
        month: 'Mar',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 95,
        resolved: 88,
        satisfaction: 3.9,
        avgHours: 19.0,
      },
      {
        month: 'Mar',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 110,
        resolved: 90,
        satisfaction: 3.7,
        avgHours: 26.0,
      },
      {
        month: 'Mar',
        category: 'Account Issue',
        priority: 'High',
        tickets: 72,
        resolved: 70,
        satisfaction: 4.1,
        avgHours: 2.8,
      },
      {
        month: 'Mar',
        category: 'Billing',
        priority: 'Medium',
        tickets: 60,
        resolved: 59,
        satisfaction: 4.4,
        avgHours: 2.0,
      },
      {
        month: 'Apr',
        category: 'Bug Report',
        priority: 'High',
        tickets: 130,
        resolved: 122,
        satisfaction: 3.7,
        avgHours: 7.0,
      },
      {
        month: 'Apr',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 82,
        resolved: 78,
        satisfaction: 4.2,
        avgHours: 15.0,
      },
      {
        month: 'Apr',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 95,
        resolved: 80,
        satisfaction: 4.0,
        avgHours: 20.0,
      },
      {
        month: 'Apr',
        category: 'Account Issue',
        priority: 'High',
        tickets: 62,
        resolved: 61,
        satisfaction: 4.4,
        avgHours: 2.0,
      },
      {
        month: 'Apr',
        category: 'Billing',
        priority: 'Medium',
        tickets: 48,
        resolved: 47,
        satisfaction: 4.7,
        avgHours: 1.2,
      },
      {
        month: 'May',
        category: 'Bug Report',
        priority: 'High',
        tickets: 150,
        resolved: 142,
        satisfaction: 3.6,
        avgHours: 6.5,
      },
      {
        month: 'May',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 98,
        resolved: 94,
        satisfaction: 4.1,
        avgHours: 14.0,
      },
      {
        month: 'May',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 105,
        resolved: 92,
        satisfaction: 4.0,
        avgHours: 18.0,
      },
      {
        month: 'May',
        category: 'Account Issue',
        priority: 'High',
        tickets: 68,
        resolved: 67,
        satisfaction: 4.5,
        avgHours: 1.8,
      },
      {
        month: 'May',
        category: 'Billing',
        priority: 'Medium',
        tickets: 52,
        resolved: 51,
        satisfaction: 4.8,
        avgHours: 1.0,
      },
      {
        month: 'Jun',
        category: 'Bug Report',
        priority: 'High',
        tickets: 135,
        resolved: 130,
        satisfaction: 3.8,
        avgHours: 5.8,
      },
      {
        month: 'Jun',
        category: 'Bug Report',
        priority: 'Low',
        tickets: 88,
        resolved: 85,
        satisfaction: 4.3,
        avgHours: 12.5,
      },
      {
        month: 'Jun',
        category: 'Feature Request',
        priority: 'Medium',
        tickets: 98,
        resolved: 85,
        satisfaction: 4.1,
        avgHours: 16.0,
      },
      {
        month: 'Jun',
        category: 'Account Issue',
        priority: 'High',
        tickets: 60,
        resolved: 59,
        satisfaction: 4.6,
        avgHours: 1.5,
      },
      {
        month: 'Jun',
        category: 'Billing',
        priority: 'Medium',
        tickets: 48,
        resolved: 48,
        satisfaction: 4.9,
        avgHours: 0.8,
      },
    ],
  },
];
